<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import { computed } from 'vue'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useEditorBetaStore } from '@/stores/editor/beta'

const betaStore = useEditorBetaStore()
const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    active: {
        type: Boolean as PropType<boolean | null>,
        default: null
    }
})

const isActive = computed(() => {
    return typeof props.active === 'boolean'
        ? props.active
        : props.editor.isActive('strike')
})

const onToggleStrike = () => {
    betaStore.getTextEditorCommandChain(props.editor)?.toggleStrike().run()
}
</script>

<template>
    <button
        @click="onToggleStrike"
        :disabled="!editor.can().chain().focus().toggleStrike().run()"
        :class="
            clsx(
                'action-strike',
                isDark ? 'dark' : 'light',
                isActive ? 'is-active' : 'is-deactive'
            )
        "
    >
        <span class="sr-only">Strike</span>

        <svg
            class="w-[25px] h-6"
            stroke="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
            fill="none"
        >
            <path
                d="M5.5 12H10.7885L13.8291 12M13.8291 12C15.7764 12 17.3546 13.567 17.3546 15.5C17.3546 17.433 15.776 19 13.8287 19H11.6706C9.5383 19 7.75963 17.497 7.35117 15.5M13.8291 12L18.7222 12M17.3544 9.375C17.3544 6.95875 15.3811 5 12.947 5H10.7889C8.84157 5 7.26296 6.567 7.26296 8.5V9.375"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-strike.light svg {
    @apply stroke-[#060606];
}

.action-strike.dark svg {
    @apply stroke-[#FAFAFA];
}

.action-strike.is-deactive svg {
    @apply opacity-60;
}

.action-strike.is-active svg {
    @apply opacity-100;
}
</style>
